import { render } from "./InspectionListitem.vue?vue&type=template&id=01aa555c"
import script from "./InspectionListitem.vue?vue&type=script&lang=js"
export * from "./InspectionListitem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__